<template>
  <main v-if="role == 'Admin' || roleIdKaryawan == $route.params.id_karyawan">
    <div class="container-fluid">
      <div
        class="page-header min-height-300"
        :style="{ backgroundImage: 'url(' + bgHeader + ')', marginRight: '-24px', marginLeft: '-34%' }"
      >
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative" v-if="karyawan.foto_karyawan">
                <img
                  :src="storageUrl+'/foto_karyawan/'+karyawan.foto_karyawan"
                  alt="profile_image"
                  class="shadow-sm w-100 border-radius-lg"
                />
              </div>
              <div class="avatar avatar-xl position-relative" v-else>
                <img
                    src="@/assets/img/avatar_karyawan.png"
                    alt="profile_image"
                    class="shadow-sm w-100 border-radius-lg"
                  />
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{ karyawan.nama }}</h5>
                <p class="mb-0 font-weight-bold text-sm">{{ karyawan.jabatan }}</p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >

                  <!-- === ABSEN === -->
                  <li class="nav-item" @click="changeTab('Absen')">
                    <a
                      class="px-0 py-1 mb-0 nav-link active"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <i class="fa fa-clock" aria-hidden="true"></i>
                      <span class="ms-1">Absen</span>
                    </a>
                  </li>

                  <!-- === PROFILE === -->
                  <li class="nav-item" @click="changeTab('Profile')">
                    <a
                      class="px-0 py-1 mb-0 nav-link "
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="true"
                    >
                      <svg
                        class="text-dark"
                        width="16px"
                        height="16px"
                        viewBox="0 0 42 42"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            transform="translate(-2319.000000, -291.000000)"
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                          >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(603.000000, 0.000000)">
                                <path
                                  class="color-background"
                                  d="M22.7597136,19.3090182 L38.8987031,11.2395234 C39.3926816,10.9925342 39.592906,10.3918611 39.3459167,9.89788265 C39.249157,9.70436312 39.0922432,9.5474453 38.8987261,9.45068056 L20.2741875,0.1378125 L20.2741875,0.1378125 C19.905375,-0.04725 19.469625,-0.04725 19.0995,0.1378125 L3.1011696,8.13815822 C2.60720568,8.38517662 2.40701679,8.98586148 2.6540352,9.4798254 C2.75080129,9.67332903 2.90771305,9.83023153 3.10122239,9.9269862 L21.8652864,19.3090182 C22.1468139,19.4497819 22.4781861,19.4497819 22.7597136,19.3090182 Z"
                                />
                                <path
                                  class="color-background"
                                  d="M23.625,22.429159 L23.625,39.8805372 C23.625,40.4328219 24.0727153,40.8805372 24.625,40.8805372 C24.7802551,40.8805372 24.9333778,40.8443874 25.0722402,40.7749511 L41.2741875,32.673375 L41.2741875,32.673375 C41.719125,32.4515625 42,31.9974375 42,31.5 L42,14.241659 C42,13.6893742 41.5522847,13.241659 41,13.241659 C40.8447549,13.241659 40.6916418,13.2778041 40.5527864,13.3472318 L24.1777864,21.5347318 C23.8390024,21.7041238 23.625,22.0503869 23.625,22.429159 Z"
                                  opacity="0.7"
                                />
                                <path
                                  class="color-background"
                                  d="M20.4472136,21.5347318 L1.4472136,12.0347318 C0.953235098,11.7877425 0.352562058,11.9879669 0.105572809,12.4819454 C0.0361450918,12.6208008 6.47121774e-16,12.7739139 0,12.929159 L0,30.1875 L0,30.1875 C0,30.6849375 0.280875,31.1390625 0.7258125,31.3621875 L19.5528096,40.7750766 C20.0467945,41.0220531 20.6474623,40.8218132 20.8944388,40.3278283 C20.963859,40.1889789 21,40.0358742 21,39.8806379 L21,22.429159 C21,22.0503869 20.7859976,21.7041238 20.4472136,21.5347318 Z"
                                  opacity="0.7"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">Profile</span>
                    </a>
                  </li>

                  <!-- === CUTI === -->
                  <li class="nav-item" @click="changeTab('Cuti')">
                    <a
                      class="px-0 py-1 mb-0 nav-link"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <svg
                        class="text-dark"
                        width="16px"
                        height="16px"
                        viewBox="0 0 40 44"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>document</title>
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            transform="translate(-1870.000000, -591.000000)"
                            fill="#FFFFFF"
                            fill-rule="nonzero"
                          >
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(154.000000, 300.000000)">
                                <path
                                  class="color-background"
                                  d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z"
                                  opacity="0.603585379"
                                />
                                <path
                                  class="color-background"
                                  d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span class="ms-1">Cuti</span>
                    </a>
                  </li>

                  <!-- === LEMBUR === -->
                  <li class="nav-item" @click="changeTab('Lembur')">
                    <a
                      class="px-0 py-1 mb-0 nav-link"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <i class="fa fa-briefcase" aria-hidden="true"></i>
                      <span class="ms-1">Lembur</span>
                    </a>
                  </li>

                  <!-- === DOKUMEN === -->
                  <li class="nav-item" @click="changeTab('Dokumen')">
                    <a
                      class="px-0 py-1 mb-0 nav-link"
                      data-bs-toggle="tab"
                      href="javascript:;"
                      role="tab"
                      aria-selected="false"
                    >
                      <i class="fa fa-folder-open" aria-hidden="true"></i>
                      <span class="ms-1">Dokumen</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TAB PROFILE -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'Profile'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <!-- <p class="mb-0">Edit Profile</p> -->
                <argon-button color="success" size="sm" class="ms-auto" @click="ChangePasswordFoto()" v-if="role == 'Users'">Change Password & Foto</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm section-title"><i class="fa fa-user"></i>Personal Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Nik</label>
                  <input type="text" class="form-control" @change="updateProfile()" placeholder="Nik" v-model="karyawan.nik">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">No Handphone</label>
                  <input type="text" class="form-control" @change="updateProfile()" placeholder="No Handphone" v-model="karyawan.no_hp">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Email</label>
                  <input type="email" class="form-control" @change="updateProfile()" placeholder="Email" v-model="karyawan.email">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Shift</label>
                  <select class="form-select" aria-label="Default select example" v-model="karyawan.shift" @change="updateProfile()">
                    <option selected>Select Shift</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="Non">Non</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tempat Lahir</label>
                  <input type="text" class="form-control" @change="updateProfile()" placeholder="Tempat Lahir" v-model="karyawan.tempat_lahir">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tanggal Lahir</label>
                  <input type="date" class="form-control" @change="updateProfile()" placeholder="Tanggal Lahir" v-model="karyawan.tgl_lahir">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Usia</label>
                  <input type="text" class="form-control" @change="updateProfile()" placeholder="Tanggal Lahir" v-model="karyawan.usia">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Alamat</label>
                  <input type="text" class="form-control" @change="updateProfile()" placeholder="Alamat" v-model="karyawan.alamat">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Jenis Kelamin</label>
                  <select class="form-select" aria-label="Default select example" v-model="karyawan.jenis_kelamin" @change="updateProfile()">
                    <option selected>Select Jenis Kelamin</option>
                    <option value="Laki - Laki">Laki - Laki</option>
                    <option value="Perempuan">Perempuan</option>
                  </select>
                </div>
              </div>

              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm section-title"><i class="fa fa-id-badge"></i>Basic Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">ID Karyawan</label>
                  <input disabled type="text" class="form-control" @change="updateProfile()" placeholder="ID Karyawan" v-model="karyawan.id_karyawan">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Nama Karyawan</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Nama Karyawan" v-model="karyawan.nama">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Jabatan</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Jabatan" v-model="karyawan.jabatan">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Unit</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Unit" v-model="karyawan.unit">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tanggal Masuk</label>
                  <input :disabled="role != 'Admin'" type="date" class="form-control" @change="updateProfile()" placeholder="Tanggal Masuk" v-model="karyawan.tgl_masuk">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Harian</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Harian" v-model="karyawan.harian">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Bulanan</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Bulanan" v-model="karyawan.bulanan">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">TJ. Jabatan / Skill</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="TJ. Jabatan / Skill" v-model="karyawan.tj_jabatan_skill">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Transport</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Transport" v-model="karyawan.transport">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Makan</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Makan" v-model="karyawan.makan">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Status</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Status" v-model="karyawan.status">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tipe Kepegawaian</label>
                  <select class="form-select" aria-label="Tipe Kepegawaian" v-model="karyawan.tipe_kepegawaian" @change="updateProfile()" :disabled="role != 'Admin'">
                    <option value="">Belum Diisi</option>
                    <option value="Permanent">Permanent</option>
                    <option value="Kontrak">Kontrak</option>
                    <option value="Harian">Harian</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tunjangan JKK</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Tunjangan JKK" v-model="karyawan.tj_jkk">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tunjangan JKM</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Status" v-model="karyawan.tj_jkm">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Tunjangan JKS</label>
                  <p class="text-xs text-secondary mb-1">
                    TJ JKS ( (Bulanan + Tj. Jabatan/Skill) * 4%) = <span class="font-weight-bold text-danger">{{ convertRp(compJks) }}</span>
                  </p>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Tunjangan JKS" v-model="karyawan.tj_jks">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">TAX Status</label>
                  <select class="form-select" aria-label="Default select example" v-model="karyawan.tax_status" @change="updateProfile()" :disabled="role != 'Admin'">
                    <option value="K0">K0</option>
                    <option value="K1">K1</option>
                    <option value="K2">K2</option>
                    <option value="K3">K3</option>
                    <option value="TK0">TK0</option>
                    <option value="TK1">KT1</option>
                    <option value="OA">OA</option>
                  </select>
                </div>
              </div>

              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm section-title"><i class="fa fa-credit-card"></i>Rekening Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Nama Bank</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Nama Bank" v-model="karyawan.bank">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">No Rekening</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="No Rekening" v-model="karyawan.no_rek">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">AN Rekening</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="AN Rekening" v-model="karyawan.an_rek">
                </div>
              </div>

              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm section-title"><i class="fa fa-heartbeat"></i>BPJS Information</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">No BPJS TK</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="No BPJS TK" v-model="karyawan.no_bpjs_tk">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">No BPJS Kes</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="No BPJS Kes" v-model="karyawan.no_bpjs_kes">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Upah BPJS</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Upah BPJS" v-model="karyawan.upah_bpjs">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">Premi BPJS Kes</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="Premi BPJS Kes" v-model="karyawan.premi_bpjs_kes">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">JHT</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="JHT" v-model="karyawan.jht">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">JKM</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="JKM" v-model="karyawan.jkm">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">JKK</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="JKK" v-model="karyawan.jkk">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">JP</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="JP" v-model="karyawan.jp">
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label mt-3">JKS</label>
                  <input :disabled="role != 'Admin'" type="text" class="form-control" @change="updateProfile()" placeholder="JKS" v-model="karyawan.jks">
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <profile-card />
        </div> -->
      </div>
    </div>

    <!-- TAB ABSEN -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'Absen'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center flex-wrap">
                <p class="font-weight-bold mb-0"><i class="fa fa-clock text-info me-1"></i> HISTORY ABSENSI</p>
                <label class="badge badge-warning ms-3 mb-0"> Hari Ini Anda Shift {{ karyawan.shift }}</label>
                <div class="ms-auto d-flex align-items-center flex-wrap justify-content-end">
                  <argon-button color="primary" size="xs" class="ms-2" style="margin-top: 5px;" @click="approveKoreksi()" v-if="tableAppKoreksi.data.length != 0"><i class="fa fa-bell fa-sm" aria-hidden="true"></i> Approval Koreksi</argon-button>
                  <argon-button color="warning" size="xs" class="ms-2" style="margin-top: 5px;" @click="historyKoreksi()"><i class="fa fa-history fa-sm" aria-hidden="true"></i> Riwayat Koreksi</argon-button>
                  <argon-button color="success" size="xs" class="ms-2" style="margin-top: 5px;" @click="createKoreksi()"><i class="fa fa-pencil fa-sm" aria-hidden="true"></i> Ajukan Koreksi</argon-button>
                  <div class="ms-3 text-end">
                    <input type="month" class="form-control form-control-sm" v-model="searchRekapAbsen.periode" @change="getRekapAbsen()">
                    <p class="text-xs text-secondary mb-0 mt-1" v-if="rekapAbsenPeriode.awal">
                      {{ moment(rekapAbsenPeriode.awal).format('D MMM') }} - {{ moment(rekapAbsenPeriode.akhir).format('D MMM YYYY') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body pb-0">
              <div class="rekap-stats">
                <div class="rekap-stat-item" v-for="stat in statDefs" :key="stat.key">
                  <p class="rekap-stat-value" :class="stat.color">{{ rekapAbsen.stats[stat.key] || 0 }}</p>
                  <p class="rekap-stat-label">{{ stat.label }}</p>
                  <div class="rekap-stat-tooltip">
                    <p class="rekap-stat-tooltip-title">{{ stat.label }}</p>
                    <div class="rekap-stat-tooltip-dates" v-if="statDates(stat.key).length">
                      <span v-for="(d, i) in statDates(stat.key)" :key="i">{{ d }}</span>
                    </div>
                    <p class="rekap-stat-tooltip-empty" v-else>Tidak ada tanggal</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0 scroll">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr style="background-color: #F0F8FF;">
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder ps-3">Date</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Shift</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Schedule In</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Schedule Out</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Clock In</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Clock Out</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Total Jam Kerja</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Attendance Code</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Time Off Code</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Overtime</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in rekapAbsen.data" :key="i">
                          <td class="ps-3">
                            <span class="text-xs font-weight-bold" :class="row.day_off ? 'text-danger' : 'text-dark'">
                              {{ moment(row.date).format('ddd, D MMM YYYY') }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm bg-gradient-danger" v-if="row.day_off && !row.clock_in && !row.clock_out">Libur</span>
                            <span class="text-secondary text-xs font-weight-bold" v-else>{{ row.shift }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs">{{ (row.day_off && !row.clock_in && !row.clock_out) ? '-' : (row.schedule_in ? row.schedule_in.substring(0,5) : '-') }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs">{{ (row.day_off && !row.clock_in && !row.clock_out) ? '-' : (row.schedule_out ? row.schedule_out.substring(0,5) : '-') }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-xs font-weight-bold" :class="(row.status == 'late_clock_in' || row.status == 'no_clock_in') ? 'text-danger' : 'text-success'">
                              {{ row.clock_in ? row.clock_in.substring(0,5) : '-' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-xs font-weight-bold" :class="(row.status == 'early_clock_out' || row.status == 'no_clock_out') ? 'text-danger' : 'text-success'">
                              {{ row.clock_out ? row.clock_out.substring(0,5) : '-' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">{{ totalJamKerja(row) }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm" :class="attendanceCodeClass(row.attendance_code)" v-if="row.attendance_code">{{ row.attendance_code }}</span>
                            <span class="text-secondary text-xs" v-else>-</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm bg-gradient-info" v-if="row.time_off_code">{{ row.time_off_code }}</span>
                            <span class="text-secondary text-xs" v-else>-</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">{{ row.overtime && row.overtime > 0 ? row.overtime + ' Jam' : '-' }}</span>
                          </td>
                        </tr>
                        <tr v-if="rekapAbsen.data.length == 0">
                          <td colspan="10" class="text-center text-sm py-3">Tidak ada data absensi</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <div class="card-footer">

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TAB CUTI -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'Cuti'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row align-items-center">
                <div class="col-lg-4">
                  <p class="font-weight-bold mb-0"><i class="fa fa-calendar-check text-success me-1"></i> HISTORY CUTI / IZIN</p>
                </div>
                <div class="col-lg-4">
                </div>
                <div class="col-lg-4">
                  <div class="float-end">
                    <argon-button color="primary" size="xs" style="margin-right: 10px; margin-top: 5px;" @click="approveCuti()" v-if="tableAppCuti.data.length != 0"><i class="fa fa-bell fa-sm" aria-hidden="true"></i> Approval Cuti / Izin</argon-button>
                    <argon-button color="success" size="xs" style="margin-right: 10px; margin-top: 5px;" @click="createCuti()" v-if="role == 'Users'"><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Ajukan Cuti</argon-button>
                    <argon-button variant="gradient" color="secondary" size="xs" style="margin-right: 10px; margin-top: 5px;" @click="filterCuti()" v-if="role == 'Users'"><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-4 col-6 mb-3">
                  <div class="stat-card stat-success">
                    <div class="stat-icon"><i class="fa fa-umbrella-beach"></i></div>
                    <div>
                      <p class="stat-label mb-0">Sisa Cuti</p>
                      <p class="stat-value mb-0">{{ sisaCuti }} <span style="font-size:0.8rem; font-weight:600; color:#8392ab;">/ {{ kuotaCuti }} Hari</span></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-6 mb-3">
                  <div class="stat-card stat-danger">
                    <div class="stat-icon"><i class="fa fa-medkit"></i></div>
                    <div>
                      <p class="stat-label mb-0">Total Sakit</p>
                      <p class="stat-value mb-0">{{ totalSakit }} Hari</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0 scroll">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr style="background-color: #F0F8FF;">
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Alasan</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Dari Tanggal</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Sampai Tanggal</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Total</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Bukti</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Approved To</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Approved Date</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Dibuat Tanggal</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in tableCuti.data" :key="i">
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.alasan_cuti }} </span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.dari_tanggal).locale('id').format('L') }} </span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.sampai_tanggal).locale('id').format('L') }} </span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.total_day }} Hari</span>
                          </td>
                          <td class="align-middle text-center">
                            <a v-if="row.bukti" :href="storageUrl+'/foto_bukti_sakit/'+row.bukti" target="_BLANK" class="text-xs font-weight-bold text-primary">
                              Bukti Surat Sakit
                            </a>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                            <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                            <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.approved_to }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.approved_date).locale('id').format('L') }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.created_at).locale('id').format('L') }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm bg-gradient-info" v-if="row.type == 'Cuti'"> {{ row.type }} </span>
                            <span class="badge badge-sm bg-gradient-danger" v-if="row.type == 'Sakit'"> {{ row.type }} </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <div class="card-footer">
              
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TAB LEMBUR -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'Lembur'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="row align-items-center">
                <div class="col-lg-4">
                  <p class="font-weight-bold mb-0"><i class="fa fa-briefcase text-warning me-1"></i> HISTORY LEMBUR</p>
                </div>
                <div class="col-lg-4">
                </div>
                <div class="col-lg-4">
                  <div class="float-end">
                    <argon-button color="primary" size="xs" style="margin-right: 10px; margin-top: 5px;" @click="approveLembur()" v-if="tableAppLembur.data.length != 0"><i class="fa fa-bell fa-sm" aria-hidden="true"></i> Approval Lembur</argon-button>
                    <argon-button color="success" size="xs" style="margin-right: 10px; margin-top: 5px;" @click="historySPL()" v-if="role == 'Users' && (karyawan.unit == 'Head Quarter' || karyawan.jabatan.includes('Leader')) "><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Buat SPL</argon-button>
                    <argon-button variant="gradient" color="secondary" size="xs" style="margin-right: 10px; margin-top: 5px;" @click="filterLembur()" v-if="role == 'Users'"><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-4 col-6 mb-3">
                  <div class="stat-card stat-info">
                    <div class="stat-icon"><i class="fa fa-hourglass-half"></i></div>
                    <div>
                      <p class="stat-label mb-0">Total Jam Lembur</p>
                      <p class="stat-value mb-0">{{ totalJamLemburMonth }} Jam</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="card-body">
              <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0 scroll">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr style="background-color: #F0F8FF;">
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Hari</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Aktual Jam</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Total Jam</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 2px;">Uraian Pekerjaan</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Approved To</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Approved Date</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Code SPL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in tableLembur.data" :key="i">
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('L') }}</span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('dddd') }} </span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.actual_jam }} Jam </span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.calculate_jam }} Jam </span>
                            <br v-if="row.cek_lembur_corrected_at">
                            <span
                              v-if="row.cek_lembur_corrected_at"
                              class="badge badge-sm bg-gradient-info"
                              style="cursor: help;"
                              :title="row.keterangan_koreksi"
                            ><i class="fa fa-info-circle" aria-hidden="true"></i> Dikoreksi Sistem</span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.uraian_pekerjaan}} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                            <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                            <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ row.approved_to }} </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.approved_date).locale('id').format('L') }}</span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="badge badge-sm bg-gradient-info"> {{ row.code_spl }} </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <div class="card-footer">
              
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TAB DOKUMEN -->
    <div class="py-4 container-fluid" style="margin-top: -0px;" v-if="tab == 'Dokumen'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="row">
              <div class="col-8">
                <div class="card-header pb-0">
                  <p class="font-weight-bold mb-0"><i class="fa fa-folder-open text-warning me-1"></i> DOKUMEN KARYAWAN</p>
                  <p class="text-xs text-secondary mb-0">Identitas, ijazah/sertifikat, kontrak kerja, dan BPJS/asuransi karyawan ini.</p>
                </div>
              </div>
              <div class="col-4" v-if="role == 'Admin'">
                <argon-button
                  class="mt-4 float-end"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="uploadDokumen()"
                ><i class="fa fa-upload fa-sm" aria-hidden="true"></i> Upload Dokumen</argon-button>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr style="background-color: #F0F8FF;">
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Kategori</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Nama Dokumen</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Keterangan</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Diupload Oleh</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in tableDokumen.data" :key="i">
                      <td class="align-middle text-sm">
                        <span class="badge badge-sm bg-gradient-info">{{ kategoriDokumenLabel(row.kategori) }}</span>
                      </td>
                      <td class="align-middle text-sm">
                        <span class="text-xs font-weight-bold">{{ row.nama_dokumen }}</span>
                      </td>
                      <td class="align-middle text-sm">
                        <span class="text-secondary text-xs">{{ row.keterangan || '-' }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs">{{ row.uploaded_by || '-' }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs">{{ moment(row.created_at).locale('id').format('L') }}</span>
                      </td>
                      <td class="align-middle text-end">
                        <i class="fa fa-download fa-sm text-secondary" aria-hidden="true" title="Download" style="cursor: pointer; margin-right: 16px;" @click="downloadDokumen(row)"></i>
                        <i v-if="role == 'Admin'" class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer;" @click="removeDokumen(row.id)"></i>
                      </td>
                    </tr>
                    <tr v-if="tableDokumen.data.length === 0">
                      <td colspan="6" class="text-center text-sm text-secondary py-4">Belum ada dokumen.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- =======  MODAL UPLOAD DOKUMEN ======= -->
    <div class="container">
      <vue-final-modal v-model="formDokumen.show" classes="modal-container" content-class="modal-content">
        <div class="row">
          <div class="col-11 float-left">
            <span class="modal__title">Upload Dokumen</span>
          </div>
          <div class="col-1 float-right">
            <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formDokumen.show = false"></i>
          </div>
        </div><hr>
        <div class="modal__content container">
          <label class="form-control-label mt-3">Kategori <span style="color: red;">*</span></label>
          <select class="form-control" v-model="dataDokumen.kategori" required>
            <option value="" disabled selected>Pilih kategori</option>
            <option v-for="opt in kategoriDokumenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>

          <label class="form-control-label mt-3">Nama Dokumen <span style="color: red;">*</span></label>
          <input type="text" class="form-control" placeholder="contoh: KTP, Ijazah S1, SK Kontrak 2026" v-model="dataDokumen.nama_dokumen" required>

          <label class="form-control-label mt-3">Keterangan (opsional)</label>
          <textarea class="form-control" rows="2" v-model="dataDokumen.keterangan"></textarea>

          <label class="form-control-label mt-3">File <span style="color: red;">*</span></label>
          <input type="file" class="form-control" @change="filesChangeDokumen">
        </div>
        <div class="row float-right mt-3">
          <div class="col-6"></div>
          <div class="col-2" style="margin-right: 20px;">
            <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="formDokumen.show = false">Close</argon-button>
          </div>
          <div class="col-1">
            <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveDokumen()">Save</argon-button>
          </div>
        </div>
      </vue-final-modal>
    </div>

  <!-- =======  MODAL FILTER ABSEN ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterAbsen.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterAbsen.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterAbsen.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <date-range-picker v-model:start-date="searchAttLog.date_start" v-model:end-date="searchAttLog.date_end" />
        <label for="example-text-input" class="form-control-label mt-3">Shift</label>
        <select class="form-select" aria-label="Default select example" v-model="searchAttLog.shift">
          <option selected>Select Shift</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="Non">Non</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5 mb-3">
        <div class="col-6"> 
        </div>
        <div class="col-2">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterAbsen.show = true">Close</argon-button> -->
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getLogAbsen()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL CHANGE PASSWORD & FOTO ======= -->
  <div class="container">
    <vue-final-modal v-model="formChangePassFoto.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formChangePassFoto.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formChangePassFoto.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Change Foto</label>
        <input type="file" class="form-control" placeholder="Change Foto" @change="filesChange">
        <label for="example-text-input" class="form-control-label mt-3">Change Password</label>
        <input type="text" class="form-control" placeholder="Change Password" v-model="changePassFoto.password">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formChangePassFoto.show = true">Close</argon-button> -->
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="changePassFotoFunct()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FILTER CUTI / IZIN ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterCuti.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterCuti.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterCuti.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <date-range-picker v-model:start-date="searchCuti.date_start" v-model:end-date="searchCuti.date_end" />
        <label for="example-text-input" class="form-control-label mt-3">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="searchCuti.type">
          <option selected>Select Type</option>
          <option value="Cuti">Cuti</option>
          <option value="Sakit">Sakit</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Status</label>
        <select class="form-select" aria-label="Default select example" v-model="searchCuti.status">
          <option selected>Select Status</option>
          <option value="Approved">Approved</option>
          <option value="Not Approved">Not Approved</option>
          <option value="Waiting">Waiting</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5 mb-3">
        <div class="col-6"> 
        </div>
        <div class="col-2">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterCuti.show = true">Close</argon-button> -->
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getDataCuti()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL AJUKAN CUTI ======= -->
  <div class="container">
    <vue-final-modal v-model="formCuti.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formCuti.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formCuti.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Type <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="dataCuti.type">
          <option selected>Type</option>
          <option value="Cuti">Cuti</option>
          <option value="Sakit">Sakit</option>
        </select>
        <template v-if="dataCuti.type == 'Sakit'">
          <label for="example-text-input" class="form-control-label mt-3">Upload Bukti <span style="color: red;">*</span></label>
          <input type="file" class="form-control" placeholder="Upload Bukti" @change="filesChangeBukti" style="margin-bottom: 20px;">
        </template>
        <label for="example-text-input" class="form-control-label mt-3">Alasan <span style="color: red;">*</span></label>
        <textarea class="form-control" v-model="dataCuti.alasan_cuti"></textarea>
        <label for="example-text-input" class="form-control-label mt-3">Dari Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Dari Tanggal" v-model="dataCuti.dari_tanggal" :min="moment().locale('id').format('YYYY-MM-Do')">
        <label for="example-text-input" class="form-control-label mt-3">Sampai Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Sampai Tanggal" v-model="dataCuti.sampai_tanggal" :min="moment().locale('id').format('YYYY-MM-Do')">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formCuti.show = true">Close</argon-button> -->
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveCuti()" :disabled="onLoading == true || (dataCuti.type == 'Cuti' && sisaCuti <= 0)">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else-if="(dataCuti.type == 'Cuti' && sisaCuti <= 0)">Batas Cuti Habis</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL APPROVAL CUTI ======= -->
  <div class="container">
    <vue-final-modal v-model="formAppCuti.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="modal-header-pretty">
        <div class="d-flex align-items-center">
          <div class="modal-header-icon bg-gradient-info"><i class="fa fa-bell"></i></div>
          <div class="ms-2">
            <p class="modal-header-title">{{formAppCuti.title}}</p>
            <p class="modal-header-subtitle">{{ tableAppCuti.data.filter(r => r.status_approval == 'Waiting').length }} menunggu tindakan &middot; {{ tableAppCuti.data.length }} total</p>
          </div>
        </div>
        <i class="fa fa-times modal-close-btn" aria-hidden="true" @click="formAppCuti.show = false"></i>
      </div>
      <!-- end header -->
      <div class="modal__content container">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0 table-hover-row">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Dibuat Oleh</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Dibuat</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Type</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Alasan</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Dari Tanggal</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Sampai Tanggal</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Total</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Bukti</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Konfirm</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableAppCuti.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.dibuat_oleh }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.created_at).locale('id').format('L') }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="row.type == 'Cuti'"> {{ row.type }} </span>
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.type == 'Sakit'"> {{ row.type }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.alasan_cuti }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.dari_tanggal).locale('id').format('L') }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.sampai_tanggal).locale('id').format('L') }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.total_day }} Hari</span>
                </td>
                <td class="align-middle text-center">
                  <a v-if="row.bukti" :href="storageUrl+'/foto_bukti_sakit/'+row.bukti" target="_BLANK" class="text-xs font-weight-bold text-primary">
                    Bukti Surat Sakit
                  </a>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                </td>
                <td class="align-middle text-center">
                  <template v-if="row.status_approval == 'Waiting'">
                    <argon-button color="success" size="xs" class="ms-auto" style="margin-right: 8px;" @click="konfirmasiCuti(row.id, 'Approved')"> Approved</argon-button>
                    <argon-button color="danger" size="xs" class="ms-auto" @click="konfirmasiCuti(row.id, 'Not Approved')"> Not Approved</argon-button>
                  </template>
                  <span class="text-secondary" v-else>&mdash;</span>
                </td>
              </tr>
              <tr v-if="tableAppCuti.data.length == 0">
                <td colspan="10" class="text-center text-sm py-4 text-secondary">Tidak ada pengajuan cuti/izin</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FILTER LEMBUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterLembur.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterLembur.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterLembur.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <date-range-picker v-model:start-date="searchLembur.date_start" v-model:end-date="searchLembur.date_end" />
        <label for="example-text-input" class="form-control-label mt-3">Status</label>
        <select class="form-select" aria-label="Default select example" v-model="searchLembur.status">
          <option selected>Select Status</option>
          <option value="Approved">Approved</option>
          <option value="Not Approved">Not Approved</option>
          <option value="Waiting">Waiting</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Code SPL</label>
        <input type="text" class="form-control" placeholder="Code SPL" v-model="searchLembur.code_spl">
        <label for="example-text-input" class="form-control-label mt-3">Periode</label>
        <input type="month" class="form-control" v-model="searchLembur.periode" @change="onPeriodeLemburChange()">
      </div>
      <!-- footer -->
      <div class="row float-right mt-5 mb-3">
        <div class="col-6"> 
        </div>
        <div class="col-2">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterLembur.show = true">Close</argon-button> -->
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getDataLembur()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL SPL BER DASARKAN YANG BUAT NYA ======= -->
  <div class="container">
    <vue-final-modal v-model="formHisSpl.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="modal-header-pretty">
        <div class="d-flex align-items-center">
          <div class="modal-header-icon bg-gradient-warning"><i class="fa fa-briefcase"></i></div>
          <div class="ms-2">
            <p class="modal-header-title">{{formHisSpl.title}}</p>
            <p class="modal-header-subtitle">{{ tableHisLembur.data.length }} SPL tercatat</p>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <argon-button color="success" size="xs" class="me-3" @click="createSPL()"><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Buat SPL</argon-button>
          <i class="fa fa-times modal-close-btn" aria-hidden="true" @click="formHisSpl.show = false"></i>
        </div>
      </div>
      <!-- end header -->
      <div class="modal__content container">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0 table-hover-row">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Dibuat Oleh</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Dibuat</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Lembur</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Aktual Jam</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Total Anggota</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Code SPL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableHisLembur.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.created_by }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.created_at).locale('id').format('L') }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('L') }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.actual_jam }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.total_anggota }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-info" style="cursor: pointer;" @click="showDetailSPL(row.code_spl)"> {{ row.code_spl }} </span>
                </td>
              </tr>
              <tr v-if="tableHisLembur.data.length == 0">
                <td colspan="7" class="text-center text-sm py-4 text-secondary">Belum ada SPL yang dibuat</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL CREATE SPL ======= -->
  <div class="container">
    <vue-final-modal v-model="formSPL.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row d-none d-md-block">
        <div class="col-11 float-left">
          <span class="modal__title">{{formSPL.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSPL.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row">
          <div class="col">
            <div class="float-end">
              <a class="btn btn-xs btn-warning d-none d-md-block" :href="apiUrl+'print-pdf/spl?code_spl='+dataSPL.code_spl" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
            </div>
          </div>
        </div>
        <h5 class="text-center font-weight-bold mb-3" style="margin-top: -50px;">Surat Perintah Lembur</h5>
        <hr class="horizontal dark mb-3" />
        <p>Dengan ini di perintahkan untuk melaksanakan pekerjaan lembur di luar hari/jam kerja</p>
        <p>Code SPL &ensp;&nbsp;&ensp;&nbsp;&ensp; : <input style="border: 1px solid white;" v-model="dataSPL.code_spl" size="8" @change="getAnggotaToTableSPL()"></p>
        <p style="margin-top: -13px;">
          Tanggal &ensp;&nbsp;&ensp;&nbsp;&ensp;&nbsp;&ensp;&nbsp;: <input type="date" style="border: 1px solid white;" v-model="dataSPL.tanggal" :disabled="tableAnggotaToTableSPL.data.length !== 0" :min="moment().locale('id').format('YYYY-MM-Do')">
        </p>
        <p style="margin-top: -13px;">
          Total Aktual Jam &ensp;: <input style="border: 1px solid white;" v-model="dataSPL.jam" size="2" :disabled="tableAnggotaToTableSPL.data.length !== 0"> Jam
        </p>
        <p style="margin-top: -13px;">
          Uraian Pekerjaan : <textarea style="border: 1px dotted dimgray; border-radius: 15px 15px 15px 15px;; resize: none; width: 100%;" placeholder="Masukkan Uraian Pekerjaan ...." rows="5" v-model="dataSPL.uraian_pekerjaan" :disabled="tableAnggotaToTableSPL.data.length !== 0"></textarea>
        </p>
        <div>
          <span class="text-center">Dengan Anggota Sebagai Berikut</span><br>
          <argon-button :disabled="(dataSPL.tanggal == undefined) && (dataSPL.jam == undefined)" color="success" size="xs" class="justify-content-end mb-2" @click="tambahAnggotaLembur()" v-if="role == 'Users'"><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Tambah Anggota</argon-button>
        </div>
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">NAMA</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">POSISI</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">UNIT</th>
                <th v-if="tableAnggotaToTableSPL.data.length !== 0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableAnggotaToTableSPL.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.nama }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.posisi }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.unit }} </span>
                </td>
                <td style="text-align: center;" v-if="row.created_by == roleFullName">
                  <i class="fa fa-times-circle fa-lg" aria-hidden="true" title="Delete" style="cursor: pointer;" @click="removeAnggota(row.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- footer -->
      <div class="row float-right">
        <div class="col-8"> 
        </div>
        <div class="col-4">
          <argon-button color="success" variant="gradient" size="xs mb-4" width="1" @click="generateRandomString(), dataSPL = {}, formSPL.show = false"><i class="fa fa-check" aria-hidden="true"></i> Selesai</argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL TAMBAH ANGGOTA LEMBUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formAnggotaLembur.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formAnggotaLembur.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formAnggotaLembur.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Search Anggota </label>
        <input type="text" class="form-control mb-3" placeholder="Keyword : Nama, Posisi/Jabatan, Unit" v-model="searchAnggota" @keyup="getAnggota()">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">NAMA</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">POSISI</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">UNIT</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableSearchAnggota.data" :key="i">
                <td class="align-middle text-left text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.nama }} </span>
                </td>
                <td class="align-middle text-left">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.jabatan }} </span>
                </td>
                <td class="align-middle text-left">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.unit }} </span>
                </td>
                <td>
                  <i class="fa fa-plus-square text-primary" title="Add Anggota" style="cursor: pointer;" @click="addSPL(row.id_karyawan)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL APPROVAL LEMBUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formAppLembur.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="modal-header-pretty">
        <div class="d-flex align-items-center">
          <div class="modal-header-icon bg-gradient-info"><i class="fa fa-bell"></i></div>
          <div class="ms-2">
            <p class="modal-header-title">{{formAppLembur.title}}</p>
            <p class="modal-header-subtitle">{{ tableAppLembur.data.filter(r => r.status_approval == 'Waiting').length }} menunggu tindakan &middot; {{ tableAppLembur.data.length }} total</p>
          </div>
        </div>
        <i class="fa fa-times modal-close-btn" aria-hidden="true" @click="formAppLembur.show = false"></i>
      </div>
      <!-- end header -->
      <div class="modal__content container">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0 table-hover-row">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Dibuat Oleh</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Dibuat</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Code SPL</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">HARI</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Lembur</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Aktual Jam</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Total Anggota</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Konfirm</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableAppLembur.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.created_by }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.created_at).locale('id').format('L') }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-info" style="cursor: pointer;" @click="showDetailSPL(row.code_spl)"> {{ row.code_spl }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('dddd') }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('L') }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.actual_jam }} </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold"> {{ row.total_anggota }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                </td>
                <td class="align-middle text-center">
                  <template v-if="row.status_approval == 'Waiting'">
                    <argon-button color="success" size="xs" class="ms-auto" style="margin-right: 8px;" @click="konfirmasiLembur(row.code_spl, 'Approved')"> Approved</argon-button>
                    <argon-button color="danger" size="xs" class="ms-auto" @click="konfirmasiLembur(row.code_spl, 'Not Approved')"> Not Approved</argon-button>
                  </template>
                  <span class="text-secondary" v-else>&mdash;</span>
                </td>
              </tr>
              <tr v-if="tableAppLembur.data.length == 0">
                <td colspan="9" class="text-center text-sm py-4 text-secondary">Tidak ada pengajuan lembur</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FORM KOREKSI KEHADIRAN ======= -->
  <div class="container">
    <vue-final-modal v-model="formKoreksi.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formKoreksi.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formKoreksi.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Tanggal" v-model="dataKoreksi.tanggal" :max="moment().format('YYYY-MM-DD')">
        <label for="example-text-input" class="form-control-label mt-3">Jenis Koreksi <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Jenis Koreksi" v-model="dataKoreksi.jenis_koreksi">
          <option value="">Pilih Jenis Koreksi</option>
          <option value="Lupa Clock In">Lupa Clock In</option>
          <option value="Lupa Clock Out">Lupa Clock Out</option>
          <option value="Lupa Clock In & Clock Out">Lupa Clock In & Clock Out</option>
          <option value="Salah Jam">Salah Jam Clock In/Out</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Jam Masuk Seharusnya</label>
        <input type="time" class="form-control" v-model="dataKoreksi.jam_masuk_koreksi">
        <label for="example-text-input" class="form-control-label mt-3">Jam Keluar Seharusnya</label>
        <input type="time" class="form-control" v-model="dataKoreksi.jam_keluar_koreksi">
        <label for="example-text-input" class="form-control-label mt-3">Alasan <span style="color: red;">*</span></label>
        <textarea class="form-control" v-model="dataKoreksi.alasan" placeholder="Contoh: Lupa tap finger saat masuk"></textarea>
        <label for="example-text-input" class="form-control-label mt-3">Upload Bukti (opsional)</label>
        <input type="file" class="form-control" @change="filesChangeBuktiKoreksi">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formKoreksi.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveKoreksi()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
  </div>

  <!-- =======  MODAL RIWAYAT KOREKSI KEHADIRAN ======= -->
  <div class="container">
    <vue-final-modal v-model="formHisKoreksi.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="modal-header-pretty">
        <div class="d-flex align-items-center">
          <div class="modal-header-icon bg-gradient-warning"><i class="fa fa-pencil"></i></div>
          <div class="ms-2">
            <p class="modal-header-title">{{formHisKoreksi.title}}</p>
            <p class="modal-header-subtitle">{{ tableKoreksi.data.length }} pengajuan tercatat</p>
          </div>
        </div>
        <i class="fa fa-times modal-close-btn" aria-hidden="true" @click="formHisKoreksi.show = false"></i>
      </div>
      <!-- end header -->
      <div class="modal__content container">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0 table-hover-row">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Koreksi</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Jenis</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Jam Masuk</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Jam Keluar</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Alasan</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Bukti</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Diajukan Ke</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableKoreksi.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ moment(row.tanggal).format('D MMM YYYY') }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.jenis_koreksi }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.jam_masuk_koreksi ? row.jam_masuk_koreksi.substring(0,5) : '-' }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.jam_keluar_koreksi ? row.jam_keluar_koreksi.substring(0,5) : '-' }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.alasan }}</span>
                </td>
                <td class="align-middle text-center">
                  <a v-if="row.bukti" :href="storageUrl+'/foto_bukti_koreksi_absen/'+row.bukti" target="_BLANK" class="text-xs font-weight-bold text-primary">Lihat Bukti</a>
                  <span class="text-secondary text-xs" v-else>-</span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.approved_to }}</span>
                </td>
              </tr>
              <tr v-if="tableKoreksi.data.length == 0">
                <td colspan="8" class="text-center text-sm py-4 text-secondary">Belum ada pengajuan koreksi kehadiran</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL APPROVAL KOREKSI KEHADIRAN ======= -->
  <div class="container">
    <vue-final-modal v-model="formAppKoreksi.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="modal-header-pretty">
        <div class="d-flex align-items-center">
          <div class="modal-header-icon bg-gradient-info"><i class="fa fa-bell"></i></div>
          <div class="ms-2">
            <p class="modal-header-title">{{formAppKoreksi.title}}</p>
            <p class="modal-header-subtitle">{{ tableAppKoreksi.data.filter(r => r.status_approval == 'Waiting').length }} menunggu tindakan &middot; {{ tableAppKoreksi.data.length }} total</p>
          </div>
        </div>
        <i class="fa fa-times modal-close-btn" aria-hidden="true" @click="formAppKoreksi.show = false"></i>
      </div>
      <!-- end header -->
      <div class="modal__content container">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0 table-hover-row">
            <thead>
              <tr style="background-color: #F0F8FF;">
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Dibuat Oleh</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Tanggal Koreksi</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Jenis</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Jam Masuk</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Jam Keluar</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Alasan</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Bukti</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Status</th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Konfirm</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableAppKoreksi.data" :key="i">
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.dibuat_oleh }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ moment(row.tanggal).format('D MMM YYYY') }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.jenis_koreksi }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.jam_masuk_koreksi ? row.jam_masuk_koreksi.substring(0,5) : '-' }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.jam_keluar_koreksi ? row.jam_keluar_koreksi.substring(0,5) : '-' }}</span>
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.alasan }}</span>
                </td>
                <td class="align-middle text-center">
                  <a v-if="row.bukti" :href="storageUrl+'/foto_bukti_koreksi_absen/'+row.bukti" target="_BLANK" class="text-xs font-weight-bold text-primary">Lihat Bukti</a>
                  <span class="text-secondary text-xs" v-else>-</span>
                </td>
                <td class="align-middle text-center">
                  <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                  <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                </td>
                <td class="align-middle text-center">
                  <template v-if="row.status_approval == 'Waiting'">
                    <argon-button color="success" size="xs" class="ms-auto" style="margin-right: 8px;" @click="konfirmasiKoreksi(row.id, 'Approved')"> Approved</argon-button>
                    <argon-button color="danger" size="xs" class="ms-auto" @click="konfirmasiKoreksi(row.id, 'Not Approved')"> Not Approved</argon-button>
                  </template>
                  <span class="text-secondary" v-else>&mdash;</span>
                </td>
              </tr>
              <tr v-if="tableAppKoreksi.data.length == 0">
                <td colspan="9" class="text-center text-sm py-4 text-secondary">Tidak ada pengajuan koreksi kehadiran</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>

  </main>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonButton from "@/components/ArgonButton.vue";
import config from '@/configs/config';
import Api from '@/helpers/api';
import { VueFinalModal } from 'vue-final-modal';
var moment = require('moment');
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import dataKaryawan from '@/services/dataKaryawan.service';
import approvalCuti from '@/services/approvalCuti.service';
import approvalLembur from '@/services/approvalLembur.service';
import akun from '@/services/akun.service';
import dataAbsensi from '@/services/dataAbsensi.service';
import koreksiAbsen from '@/services/koreksiAbsen.service';
import dokumenKaryawan from '@/services/dokumenKaryawan.service';
import bgHeader from '@/assets/img/bg_login_bck.jpg';
import { periodeToRange } from '@/helpers/periode';
import DateRangePicker from '@/components/DateRangePicker.vue';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  data() {
    return {
      moment:moment,
      bgHeader: bgHeader,
      showMenu: false,
      onLoading: false,
      karyawan: {},
      tab: 'Absen',
      formFilterAbsen: {
        add: true,
        title: "Filter Absen",
        show: false
      },
      formFilterCuti: {
        add: true,
        title: "Filter Cuti Izin",
        show: false
      },
      formFilterLembur: {
        add: true,
        title: "Filter Lembur",
        show: false
      },
      formCuti: {
        add: true,
        title: "Form Pengajuan Cuti / Izin",
        show: false
      },
      formHisSpl: {
        add: true,
        title: "SPL Yang Anda Buat",
        show: false
      },
      formSPL: {
        add: true,
        title: "Form Surat Perintah Lembur",
        show: false
      },
      formAnggotaLembur: {
        add: true,
        title: "Tambah Anggota Lembur",
        show: false
      },
      formAppCuti: {
        add: true,
        title: "Form Approval Cuti",
        show: false
      },
      formAppLembur: {
        add: true,
        title: "Form Approval Lembur",
        show: false
      },
      formChangePassFoto: {
        add: true,
        title: "Form Change Password & Foto",
        show: false
      },
      formKoreksi: {
        add: true,
        title: "Form Koreksi Kehadiran",
        show: false
      },
      formHisKoreksi: {
        add: true,
        title: "Riwayat Koreksi Kehadiran",
        show: false
      },
      formAppKoreksi: {
        add: true,
        title: "Approval Koreksi Kehadiran",
        show: false
      },
      changePassFoto: {},
      dataCuti: {
        tanggal: '',
        jam: '',
      },
      dataKoreksi: {
        tanggal: '',
        jenis_koreksi: '',
        jam_masuk_koreksi: '',
        jam_keluar_koreksi: '',
        alasan: '',
      },
      dataSPL: {},
      tableAttLog: {
        data: []
      },
      rekapAbsen: {
        data: [],
        stats: {}
      },
      searchRekapAbsen: {
        // 16-15 payroll cycle convention used across the app: the value is
        // the month the cycle STARTS in, e.g. '2026-09' = 16 Sep - 15 Oct.
        periode: (moment().date() >= 16) ? moment().format('YYYY-MM') : moment().subtract(1, 'months').format('YYYY-MM')
      },
      rekapAbsenPeriode: {
        awal: '',
        akhir: '',
      },
      statDefs: [
        { key: 'on_time',        label: 'On time',         color: '' },
        { key: 'late_clock_in',  label: 'Late clock in',   color: 'text-warning' },
        { key: 'early_clock_out',label: 'Early clock out', color: 'text-warning' },
        { key: 'no_clock_out',   label: 'No clock out',    color: 'text-danger' },
        { key: 'no_clock_in',    label: 'No clock in',     color: 'text-danger' },
        { key: 'invalid',        label: 'Invalid',         color: 'text-danger' },
        { key: 'absent',         label: 'Absent',          color: 'text-danger' },
        { key: 'day_off',        label: 'Day off',         color: '' },
        { key: 'time_off',       label: 'Time off',        color: '' },
        { key: 'next_workdays',  label: 'Next workdays',   color: '' },
      ],
      tableCuti: {
        data: []
      },
      tableAppCuti: {
        data: []
      },
      tableKoreksi: {
        data: []
      },
      tableAppKoreksi: {
        data: []
      },
      tableHisLembur: {
        data: []
      },
      tableAppLembur: {
        data: []
      },
      tableLembur: {
        data: []
      },
      tableDokumen: {
        data: []
      },
      formDokumen: {
        show: false,
      },
      dataDokumen: {},
      kategoriDokumenOptions: [
        { value: 'identitas', label: 'Identitas (KTP/KK)' },
        { value: 'ijazah', label: 'Ijazah / Sertifikat' },
        { value: 'kontrak', label: 'Kontrak Kerja / SK' },
        { value: 'bpjs', label: 'BPJS / Asuransi' },
      ],
      tableSearchAnggota: {
        data: []
      },
      tableAnggotaToTableSPL: {
        data: []
      },
      totalCuti: '',
      totalSakit: '',
      sisaCuti: '',
      kuotaCuti: 12,
      totalJamLemburMonth: '',
      role: '',
      roleIdKaryawan: '',
      roleFullName: '',
      storageUrl : config.storageUrl,
      searchAnggota: '',
      apiUrl :config.apiUrl,
      searchAttLog: {
        shift: '',
        date_start: '',
        date_end: '',
        type: '',
      },
      searchCuti: {
        date_start: '',
        date_end: '',
        type: '',
        status: '',
      },
      searchLembur: {
        date_start: '',
        date_end: '',
        status: '',
        code_spl: '',
        periode: '',
        periode_start: '',
        periode_end: '',
      }
    };
  },
  computed: {
    compJks() {
      return this.calcJks(this.karyawan);
    }
  },
  components: {
    ArgonButton,
    VueFinalModal,
    DateRangePicker,
  },
  mounted() {
    this.getDataProfile();
    this.getRekapAbsen();
    this.getDataKoreksi();
    this.getRole();
    this.$store.state.isAbsolute = true;
    setNavPills();
    setTooltip();
  },
  methods: {
    getDataProfile() {
      let context = this;
      Api(context, dataKaryawan.show(context.$route.params.id_karyawan)).onSuccess(function(response) {
          context.karyawan = response.data.data;
          if (context.karyawan.tj_jks === null || context.karyawan.tj_jks === undefined || context.karyawan.tj_jks === '') {
            context.karyawan.tj_jks = context.calcJks(context.karyawan);
          }
      })
      .call()
    },
    calcJks(k) {
      const sum = (Number(k.bulanan) || 0)
                + (Number(k.tj_jabatan_skill) || 0);
      return Math.round(sum * 0.04);
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
      return 0;
    },
    getRekapAbsen(){
      let context = this;

      Api(context, dataAbsensi.getRekapAbsen({id_karyawan: context.$route.params.id_karyawan, periode: context.searchRekapAbsen.periode})).onSuccess(function(response) {
          context.rekapAbsen.data       = response.data.data.data;
          context.rekapAbsen.stats      = response.data.data.stats;
          context.rekapAbsenPeriode.awal  = response.data.data.periode_awal;
          context.rekapAbsenPeriode.akhir = response.data.data.periode_akhir;
      }).onError(function() {
          context.rekapAbsen.data  = [];
          context.rekapAbsen.stats = {};
      })
      .call()
    },
    statDates(statusKey) {
      return this.rekapAbsen.data
        .filter(row => row.status == statusKey)
        .map(row => this.moment(row.date).format('ddd, D MMM'));
    },
    totalJamKerja(row) {
      if (!row.clock_in || !row.clock_out) {
        return '-';
      }
      let start = this.moment(row.clock_in, 'HH:mm:ss');
      let end   = this.moment(row.clock_out, 'HH:mm:ss');
      if (end.isBefore(start)) {
        end.add(1, 'day'); // shift overnight (clock out past midnight)
      }
      let totalMenit = end.diff(start, 'minutes');
      let jam  = Math.floor(totalMenit / 60);
      let menit = totalMenit % 60;
      return jam + ' Jam ' + menit + ' Menit';
    },
    attendanceCodeClass(code) {
      const map = {
        H: 'bg-gradient-primary',  // Hadir
        A: 'bg-gradient-danger',   // Alpa
        C: 'bg-gradient-info',     // Cuti
        S: 'bg-gradient-warning',  // Sakit
        I: 'badge-code-ungu',      // Ijin
        L: 'bg-gradient-success',  // Libur / Lembur
      };
      return map[code] || 'bg-gradient-secondary';
    },
    getLogAbsen(){
      let context = this;

      Api(context, dataAbsensi.attLogIdKaryawan({id_karyawan: context.$route.params.id_karyawan, shift: context.searchAttLog.shift, date_start: context.searchAttLog.date_start, date_end: context.searchAttLog.date_end, type: context.searchAttLog.type})).onSuccess(function(response) {
          context.tableAttLog.data = response.data.data;
          console.log(response.data.data)
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableAttLog.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
          context.formFilterAbsen.show  = false;
      })
      .call()
    },
    getRole(){
      let context = this;     
      context.onLoading = true;          
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role           = response.data.data[0].role;
          context.roleIdKaryawan = response.data.data[0].employee_id;
          context.roleFullName   = response.data.data[0].full_name;
      }).onError(function(error) {  
      })
      .call() 
    },
    updateProfile(){
      let api     = null;
      let context = this;

      api = Api(context, dataKaryawan.update(context.karyawan.id, {
          id_karyawan: context.karyawan.id_karyawan,
          nama: context.karyawan.nama,
          jabatan: context.karyawan.jabatan,
          unit: context.karyawan.unit,
          tgl_masuk: context.karyawan.tgl_masuk,
          harian: context.karyawan.harian,
          bulanan: context.karyawan.bulanan,
          transport: context.karyawan.transport,
          makan: context.karyawan.makan,
          tj_jabatan_skill: context.karyawan.tj_jabatan_skill,
          status: context.karyawan.status,
          tipe_kepegawaian: context.karyawan.tipe_kepegawaian,
          tj_jkk: context.karyawan.tj_jkk,
          tj_jkm: context.karyawan.tj_jkm,
          tj_jks: context.karyawan.tj_jks,
          tax_status: context.karyawan.tax_status,

          bank: context.karyawan.bank,
          no_rek: context.karyawan.no_rek,
          an_rek: context.karyawan.an_rek,

          no_bpjs_tk: context.karyawan.no_bpjs_tk,
          no_bpjs_kes: context.karyawan.no_bpjs_kes,
          upah_bpjs: context.karyawan.upah_bpjs,
          premi_bpjs_kes: context.karyawan.premi_bpjs_kes,
          jht: context.karyawan.jht,
          jkm: context.karyawan.jkm,
          jkk: context.karyawan.jkk,
          jp: context.karyawan.jp,
          jks: context.karyawan.jks,

          nik: context.karyawan.nik,
          no_hp: context.karyawan.no_hp,
          email: context.karyawan.email,
          shift: context.karyawan.shift,

          tempat_lahir: context.karyawan.tempat_lahir,
          tgl_lahir: context.karyawan.tgl_lahir,
          usia: context.karyawan.usia,
          alamat: context.karyawan.alamat,
          jenis_kelamin: context.karyawan.jenis_kelamin,
          total_cuti: context.karyawan.total_cuti,
        }));
      api.onSuccess(function(response) {
          context.notify('Update Success', 'success')
      }).onError(function(error) { 
          context.notify('Update Failed', 'error')
      }).onFinish(function() {  
      })
      .call();
    },
    changeTab(tab){
      this.tab = tab
      if (tab == 'Absen') {
        this.getRekapAbsen();
        this.getDataKoreksi();
      }else if(tab == 'Profile'){
        this.getDataProfile();
      }else if(tab == 'Cuti'){
        this.getDataCuti();
        this.searchCuti = {}
      }else if(tab == 'Lembur'){
        this.getDataLembur();
        this.searchLembur = {}
      }else if(tab == 'Dokumen'){
        this.getDataDokumen();
      }
    },
    ChangePasswordFoto() {
      this.formChangePassFoto.add   = true;
      this.formChangePassFoto.show  = true;
      this.formChangePassFoto.title = "Form Change Password & Foto";
      this.onLoading = false;
    },
    filesChange(e) {
        this.changePassFoto.foto = e.target.files[0];
    },
    filesChangeBukti(e) {
        this.dataCuti.bukti = e.target.files[0];
    },
    filesChangeBuktiKoreksi(e) {
        this.dataKoreksi.bukti = e.target.files[0];
    },
    changePassFotoFunct(){
      let api = null;
      let context = this;
      let formData = new FormData();
      this.onLoading = true;

      formData.append('id_karyawan', this.karyawan.id);
      formData.append('employee_id', this.karyawan.id_karyawan);
      formData.append('foto', (this.changePassFoto.foto == undefined) ? '' : this.changePassFoto.foto);
      formData.append('password', (this.changePassFoto.password == undefined) ? '' : this.changePassFoto.password);

      api = Api(context, dataKaryawan.changePassFoto(formData));
      api.onSuccess(function(response) {
          context.notify('Change Data Success', 'success')
      }).onError(function(error) {                   
          context.notify('Change Data Failed', 'error')
      }).onFinish(function() {  
          context.onLoading = false;
          context.get();
          context.formChangePassFoto.show = false;
      })
      .call();
    },
    createCuti() {
      this.formCuti.add   = true;
      this.formCuti.show  = true;
      this.formCuti.title = "Form Pengajuan Cuti / Izin";
      this.dataCuti       = {};
      this.onLoading      = false;
    },
    historySPL() {
      this.formHisSpl.add   = true;
      this.formHisSpl.show  = true;
      this.formHisSpl.title = "SPL Yang Anda Buat";
      // this.dataSPL       = {};
      this.onLoading     = false;
    },
    createSPL() {
      this.formSPL.add   = true;
      this.formSPL.show  = true;
      this.formSPL.title = "Form Surat Perintah Lembur";
      // this.dataSPL       = {};
      this.onLoading     = false;

      if (this.dataSPL.code_spl == undefined) {
        this.generateRandomString();
      }
    },
    tambahAnggotaLembur() {
      this.formAnggotaLembur.add   = true;
      this.formAnggotaLembur.show  = true;
      this.formAnggotaLembur.title = "Tambah Anggota Lembur";
      this.onLoading               = false;
      this.getAnggotaToTableSPL()
    },
    approveCuti() {
      this.formAppCuti.add   = true;
      this.formAppCuti.show  = true;
      this.formAppCuti.title = "Form Approval Cuti";
      this.onLoading         = false;
    },
    createKoreksi() {
      this.formKoreksi.add   = true;
      this.formKoreksi.show  = true;
      this.formKoreksi.title = "Form Koreksi Kehadiran";
      this.dataKoreksi       = {};
      this.onLoading         = false;
    },
    historyKoreksi() {
      this.formHisKoreksi.add   = true;
      this.formHisKoreksi.show  = true;
      this.formHisKoreksi.title = "Riwayat Koreksi Kehadiran";
      this.onLoading            = false;
    },
    approveKoreksi() {
      this.formAppKoreksi.add   = true;
      this.formAppKoreksi.show  = true;
      this.formAppKoreksi.title = "Approval Koreksi Kehadiran";
      this.onLoading            = false;
    },
    approveLembur() {
      this.formAppLembur.add   = true;
      this.formAppLembur.show  = true;
      this.formAppLembur.title = "Form Approval Lembur";
      this.onLoading         = false;
    },
    saveCuti(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      this.onLoading = true;

      if (context.dataCuti.type != undefined && context.dataCuti.alasan_cuti != undefined && context.dataCuti.dari_tanggal != undefined && context.dataCuti.sampai_tanggal != undefined) {
        formData.append('id_karyawan', context.karyawan.id_karyawan);
        formData.append('dibuat_oleh', context.karyawan.nama);
        formData.append('type', context.dataCuti.type);
        formData.append('alasan_cuti', context.dataCuti.alasan_cuti);
        formData.append('dari_tanggal', context.dataCuti.dari_tanggal);
        formData.append('sampai_tanggal', context.dataCuti.sampai_tanggal);
      }else{
        context.onLoading = false;
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (context.dataCuti.type == 'Sakit') {
        if (context.dataCuti.bukti != undefined) {
          formData.append('bukti', context.dataCuti.bukti);
        }else{
          context.onLoading = false;
          return alert('Bukti Wajib Di Isi')
        }
      }

      if (context.formCuti.title == 'Form Pengajuan Cuti / Izin') {
          api = Api(context, approvalCuti.create(formData));
      } else {
          api = Api(context, approvalCuti.update(this.dataCuti.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getDataCuti();
        context.formCuti.show = false;
        context.notify((context.formCuti === 'Form Pengajuan Cuti / Izin') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.formCuti != 'Form Pengajuan Cuti / Izin') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {
        context.onLoading = false;
      })
      .call();
    },
    getDataCuti() {
      let context = this;               
      Api(context, approvalCuti.index({date_start: context.searchCuti.date_start, date_end: context.searchCuti.date_end, type: context.searchCuti.type, status: context.searchCuti.status, id_karyawan: context.$route.params.id_karyawan})).onSuccess(function(response) {
          context.tableCuti.data    = response.data.data.data;       
          context.tableAppCuti.data = response.data.data.dataApproval;       
          context.totalCuti         = response.data.data.totalCuti;
          context.totalSakit        = response.data.data.totalSakit;
          context.sisaCuti          = response.data.data.sisaCuti;
          context.kuotaCuti         = response.data.data.kuotaCuti;
      }).onFinish(function() {
        context.formFilterCuti.show = false;
      })
      .call()        
    },
    konfirmasiCuti(id, type){
      let api     = null;
      let context = this;

      api = Api(context, approvalCuti.update(id, {
          type: type,
        }));
      api.onSuccess(function(response) {
          context.notify('Update Success', 'success')
      }).onError(function(error) {
          context.notify(error.response?.data?.message || 'Update Failed', 'error')
      }).onFinish(function() {
        context.getDataCuti();
      })
      .call();
    },
    saveKoreksi(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      this.onLoading = true;

      if (context.dataKoreksi.tanggal != undefined && context.dataKoreksi.jenis_koreksi != undefined && context.dataKoreksi.alasan != undefined && context.dataKoreksi.jenis_koreksi != '') {
        formData.append('id_karyawan', context.karyawan.id_karyawan);
        formData.append('dibuat_oleh', context.karyawan.nama);
        formData.append('tanggal', context.dataKoreksi.tanggal);
        formData.append('jenis_koreksi', context.dataKoreksi.jenis_koreksi);
        formData.append('jam_masuk_koreksi', context.dataKoreksi.jam_masuk_koreksi || '');
        formData.append('jam_keluar_koreksi', context.dataKoreksi.jam_keluar_koreksi || '');
        formData.append('alasan', context.dataKoreksi.alasan);
      }else{
        context.onLoading = false;
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (context.dataKoreksi.jenis_koreksi.includes('Clock In') && !context.dataKoreksi.jam_masuk_koreksi) {
        context.onLoading = false;
        return alert('Jam Masuk Seharusnya Wajib Di Isi')
      }
      if (context.dataKoreksi.jenis_koreksi.includes('Clock Out') && !context.dataKoreksi.jam_keluar_koreksi) {
        context.onLoading = false;
        return alert('Jam Keluar Seharusnya Wajib Di Isi')
      }
      if (context.dataKoreksi.jenis_koreksi == 'Salah Jam' && !context.dataKoreksi.jam_masuk_koreksi && !context.dataKoreksi.jam_keluar_koreksi) {
        context.onLoading = false;
        return alert('Isi Minimal Salah Satu Jam Koreksi')
      }

      if (context.dataKoreksi.bukti != undefined) {
        formData.append('bukti', context.dataKoreksi.bukti);
      }

      api = Api(context, koreksiAbsen.create(formData));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getDataKoreksi();
        context.formKoreksi.show = false;
        context.notify('Data Berhasil di Simpan', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
        context.notify('Data Gagal di Simpan', 'error')
      }).onFinish(function() {
        context.onLoading = false;
      })
      .call();
    },
    getDataKoreksi() {
      let context = this;
      Api(context, koreksiAbsen.index({id_karyawan: context.$route.params.id_karyawan})).onSuccess(function(response) {
          context.tableKoreksi.data    = response.data.data.data;
          context.tableAppKoreksi.data = response.data.data.dataApproval;
      })
      .call()
    },
    konfirmasiKoreksi(id, type){
      let api     = null;
      let context = this;

      api = Api(context, koreksiAbsen.update(id, {
          type: type,
        }));
      api.onSuccess(function(response) {
          context.notify('Update Success', 'success')
      }).onError(function(error) {
          context.notify('Update Failed', 'error')
      }).onFinish(function() {
        context.getDataKoreksi();
      })
      .call();
    },
    konfirmasiLembur(code_spl, type){
      let api     = null;
      let context = this;

      api = Api(context, approvalLembur.appLembur(code_spl, {
          type: type,
        }));
      api.onSuccess(function(response) {
          context.notify('Update Success', 'success')
      }).onError(function(error) { 
          context.notify('Update Failed', 'error')
      }).onFinish(function() { 
        context.getDataLembur(); 
        // context.formAppLembur = false
      })
      .call();
    },
    getDataLembur() {
      let context = this;               
      Api(context, approvalLembur.index({date_start: context.searchLembur.date_start, date_end: context.searchLembur.date_end, status: context.searchLembur.status, code_spl: context.searchLembur.code_spl, periode_start: context.searchLembur.periode_start, periode_end: context.searchLembur.periode_end,})).onSuccess(function(response) {
          context.tableLembur.data    = response.data.data.data;                
          context.tableHisLembur.data = response.data.data.dataHisLembur;                
          context.tableAppLembur.data = response.data.data.dataApproval;               
          context.totalJamLemburMonth = response.data.data.totalJamLemburMonth;       
      }).onFinish(function() {
        context.formFilterLembur.show = false;
      })
      .call()
    },
    getDataDokumen() {
      let context = this;
      Api(context, dokumenKaryawan.index(this.$route.params.id_karyawan)).onSuccess(function(response) {
        context.tableDokumen.data = response.data.data;
      })
      .call()
    },
    uploadDokumen() {
      this.dataDokumen = {};
      this.formDokumen.show = true;
    },
    filesChangeDokumen(e) {
      this.dataDokumen.file = e.target.files[0];
    },
    saveDokumen() {
      let context  = this;
      let formData = new FormData();

      if (context.dataDokumen.kategori && context.dataDokumen.nama_dokumen && context.dataDokumen.file instanceof File) {
        formData.append('id_karyawan', context.$route.params.id_karyawan);
        formData.append('kategori', context.dataDokumen.kategori);
        formData.append('nama_dokumen', context.dataDokumen.nama_dokumen);
        formData.append('keterangan', context.dataDokumen.keterangan || '');
        formData.append('file', context.dataDokumen.file);
      } else {
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      Api(context, dokumenKaryawan.create(formData)).onSuccess(function() {
        context.getDataDokumen();
        context.formDokumen.show = false;
        context.notify('Dokumen Berhasil Diupload', 'success')
      }).onError(function() {
        context.notify('Dokumen Gagal Diupload', 'error')
      })
      .call();
    },
    downloadDokumen(row) {
      let context = this;
      Api(context, dokumenKaryawan.download(row.id)).onSuccess(function(response) {
        window.open(URL.createObjectURL(response.data), '_blank');
      }).onError(function() {
        context.notify('Gagal mengunduh dokumen', 'error')
      })
      .call()
    },
    removeDokumen(id) {
      var r = confirm("Anda yakin ingin menghapus dokumen ini ?");
      if (r == true) {
        let context = this;
        Api(context, dokumenKaryawan.delete(id)).onSuccess(function() {
          context.getDataDokumen();
          context.notify('Dokumen Berhasil Dihapus', 'success')
        }).onError(function() {
          context.notify('Gagal menghapus dokumen', 'error')
        }).call();
      }
    },
    kategoriDokumenLabel(value) {
      const found = this.kategoriDokumenOptions.find(o => o.value === value);
      return found ? found.label : value;
    },
    generateRandomString(){
      // GENERATE RANDOM STRING
      let length = 8;
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }

      this.dataSPL.code_spl = result;
      this.getAnggotaToTableSPL();
    },
    getAnggota(){
      let context = this;               
      Api(context, approvalLembur.searchAnggota({search : context.searchAnggota})).onSuccess(function(response) {
          context.tableSearchAnggota.data = response.data.data;     
      })
      .call()
    },
    addSPL(id_karyawan){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      this.onLoading = true;

      if (context.dataSPL.tanggal != undefined && context.dataSPL.jam != undefined) {
        formData.append('id_karyawan', id_karyawan);
        formData.append('code_spl', context.dataSPL.code_spl);
        formData.append('tanggal', context.dataSPL.tanggal);
        formData.append('jam', context.dataSPL.jam);
        formData.append('uraian_pekerjaan', context.dataSPL.uraian_pekerjaan);
      }else{
        context.onLoading = false;
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      api = Api(context, approvalLembur.create(formData));

      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getDataCuti();
        context.notify((context.formSPL === 'Form Surat Perintah Lembur') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.formSPL != 'Form Surat Perintah Lembur') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {
        context.onLoading = false;
        context.getDataLembur()
        context.getAnggotaToTableSPL()
      })
      .call();
    },
    getAnggotaToTableSPL(){
      let context = this;               
      Api(context, approvalLembur.show({code_spl : context.dataSPL.code_spl})).onSuccess(function(response) {
          context.tableAnggotaToTableSPL.data = response.data.data;
          context.dataSPL.tanggal             = response.data.data[0].tanggal
          context.dataSPL.jam                 = response.data.data[0].actual_jam
          context.dataSPL.uraian_pekerjaan    = response.data.data[0].uraian_pekerjaan 
      })
      .call()
    },
    removeAnggota(id) {
        var r = confirm("Anda yakin ingin menghapus data ini ?");
        if (r == true) {
          let context = this;

          Api(context, approvalLembur.deleteAnggota(id)).onSuccess(function(response) {
              context.getAnggotaToTableSPL();
              context.getAnggota();
              context.notify('Data Berhasil di Hapus', 'success')
          }).call();
        }
    },
    showDetailSPL(code_spl){
      this.formAppLembur.show  = false;

      this.formSPL.add      = true;
      this.formSPL.show     = true;
      this.formSPL.title    = "Form Surat Perintah Lembur";
      this.dataSPL.code_spl = code_spl;
      this.onLoading        = false;

      this.getAnggotaToTableSPL()
    },
    filterAbsen() {
      this.formFilterAbsen.add   = true;
      this.formFilterAbsen.show  = true;
      this.formFilterAbsen.title = "Filter Absen";
      this.onLoading = false;
    },
    filterCuti() {
      this.formFilterCuti.add   = true;
      this.formFilterCuti.show  = true;
      this.formFilterCuti.title = "Filter Cuti / Izin";
      this.onLoading = false;
    },
    filterLembur() {
      this.formFilterLembur.add   = true;
      this.formFilterLembur.show  = true;
      this.formFilterLembur.title = "Filter Lembur";
      this.onLoading = false;
      this.searchLembur.periode = this.searchLembur.periode_start ? moment(this.searchLembur.periode_start).format('YYYY-MM') : '';
    },
    onPeriodeLemburChange() {
      const range = periodeToRange(this.searchLembur.periode);
      this.searchLembur.periode_start = range.start;
      this.searchLembur.periode_end   = range.end;
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
<style scoped>
.modal-header-pretty {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.85rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.modal-header-icon {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.05rem;
}
.modal-header-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #344767;
  margin-bottom: 0;
}
.modal-header-subtitle {
  font-size: 0.72rem;
  color: #8392ab;
  margin-bottom: 0;
}
.modal-close-btn {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  color: #67748e;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}
.modal-close-btn:hover {
  background: #f5365c;
  color: #fff;
}
.table-hover-row tbody tr {
  transition: background-color 0.12s;
}
.table-hover-row tbody tr:hover {
  background-color: #f8f9fe;
}
.rekap-stats {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #e9ecef;
  border-radius: 0.75rem;
}
.badge-code-ungu {
  background-image: linear-gradient(310deg, #6f42c1, #8c62d6);
  color: #fff;
}
.rekap-stat-item {
  position: relative;
  flex: 1 1 10%;
  min-width: 90px;
  padding: 0.75rem 0.5rem;
  text-align: center;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  cursor: help;
  transition: background-color 0.12s;
}
.rekap-stat-item:first-child {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rekap-stat-item:last-child {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rekap-stat-item:hover {
  background-color: #f8f9fe;
}
.rekap-stat-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-6px);
  background: #252f40;
  color: #fff;
  border-radius: 0.6rem;
  padding: 0.65rem 0.85rem;
  min-width: 130px;
  max-width: 220px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, transform 0.15s ease;
  z-index: 60;
  pointer-events: none;
  text-align: left;
}
.rekap-stat-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #252f40;
}
.rekap-stat-item:hover .rekap-stat-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-10px);
}
.rekap-stat-tooltip-title {
  font-weight: 700;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #fff;
  border-bottom: 1px solid rgba(255,255,255,0.15);
  padding-bottom: 0.3rem;
  margin-bottom: 0.35rem;
}
.rekap-stat-tooltip-dates {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.rekap-stat-tooltip-dates span {
  font-size: 0.72rem;
  color: #e9ecef;
  white-space: nowrap;
}
.rekap-stat-tooltip-empty {
  font-size: 0.72rem;
  color: #adb5bd;
  margin-bottom: 0;
}
.rekap-stat-item:first-child .rekap-stat-tooltip {
  left: 0;
  transform: translateX(0) translateY(-6px);
}
.rekap-stat-item:first-child .rekap-stat-tooltip::after {
  left: 20px;
  transform: translateX(0);
}
.rekap-stat-item:first-child:hover .rekap-stat-tooltip {
  transform: translateX(0) translateY(-10px);
}
.rekap-stat-item:last-child .rekap-stat-tooltip {
  left: auto;
  right: 0;
  transform: translateX(0) translateY(-6px);
}
.rekap-stat-item:last-child .rekap-stat-tooltip::after {
  left: auto;
  right: 20px;
  transform: translateX(0);
}
.rekap-stat-item:last-child:hover .rekap-stat-tooltip {
  transform: translateX(0) translateY(-10px);
}
.rekap-stat-item:last-child {
  border-right: none;
}
.rekap-stat-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #344767;
  margin-bottom: 0.1rem;
}
.rekap-stat-label {
  font-size: 0.68rem;
  color: #8392ab;
  margin-bottom: 0;
  white-space: nowrap;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-left: 0.75rem;
  border-left: 3px solid #2dce89;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #344767;
}
.section-title i {
  color: #2dce89;
  font-size: 0.9rem;
}
.stat-card {
  border-radius: 0.75rem;
  padding: 1.1rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  height: 100%;
}
.stat-card .stat-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #fff;
}
.stat-card .stat-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #67748e;
  font-weight: 600;
  margin-bottom: 0.15rem;
}
.stat-card .stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #344767;
  line-height: 1.1;
}
.stat-card.stat-success { background: linear-gradient(180deg,#f0fff6,#e6fff0); }
.stat-card.stat-success .stat-icon { background: linear-gradient(135deg,#2dce89,#2dcecc); }
.stat-card.stat-danger { background: linear-gradient(180deg,#fff5f5,#ffecec); }
.stat-card.stat-danger .stat-icon { background: linear-gradient(135deg,#f5365c,#f56036); }
.stat-card.stat-info { background: linear-gradient(180deg,#f0f8ff,#e9f4ff); }
.stat-card.stat-info .stat-icon { background: linear-gradient(135deg,#11cdef,#1171ef); }
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}

/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  /*width: 1090px;*/
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll {
  overflow: auto;
  max-height: 60vh;
  border: 1px solid #eef0f4;
  border-radius: 0.75rem;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
.scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.scroll::-webkit-scrollbar-track {
  background: transparent;
}
.scroll::-webkit-scrollbar-thumb {
  background-color: #d3d9e6;
  border-radius: 10px;
}
.scroll::-webkit-scrollbar-thumb:hover {
  background-color: #b6bfd4;
}
</style>
